import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import AssetDetailSubpage from "../Components/AssetDetailSubpage";
import { ThemeProvider } from "@mui/material/styles";
import Table_theme from "../Themes/TableTheme";
import FormThemes from "../Themes/FormThemes";
import { ReactComponent as DeleteIcon } from "../Icons/Delete.svg";
import { ReactComponent as SettingsIcon } from "../Icons/Settings.svg";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import CloseIcon from "@mui/icons-material/Close";
import { formatDateLocal, formatDateLocal_TF } from "../utils/dateUtils";
import MainLayout from "../Themes/MainLayout";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  TextField,
  Pagination,
  Grid,
  MenuItem,
  CssBaseline,
  Tabs,
  Tab,
  Chip,
} from "@mui/material";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import {
  IconButton,
  Paper,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Alert,
  Snackbar,
  Popover,
  InputAdornment,
  Switch,
  Typography,
} from "@mui/material";

import { Add, Flag, FilterList, Search, Close } from "@mui/icons-material";
import { useCurrentUser } from "../utils/useCurrentUser";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AssetFields = [
  "asset_description",
  "purchase_at",
  "manufacturer",
  "model_no",
  "model_name",
  "serial_no",
  "price",
  "purchase_date",
  "warranty_number",
  "warranty_validity",
  "warranty_status",
  "service_date",
  "service_by",
  "installation_cost",
  "qty",
  "asset_status",
  "asset_condition",
];

const AssetpopupFields = [
  "asset_description",
  "purchase_at",
  "manufacturer",
  "model_no",
  "model_name",
  "serial_no",
  "price",
  "purchase_date",
  "warranty_number",
  "warranty_validity",
  "warranty_status",
  "service_date",
  "service_by",
  "installation_cost",
  "qty",
  "asset_status",
  "asset_condition",
];

const fieldLabels = {};
AssetFields.forEach((field) => {
  if (field === "qty") {
    fieldLabels[field] = "Quantity";
  } else {
    fieldLabels[field] = field
      .replace(/_/g, " ")
      .replace(/\b\w/g, (l) => l.toUpperCase());
  }
});

const returnHistoryFields = [
  "employee_name",
  "asset_description",
  "model_no",
  "serial_no",
  "transaction_status",
  "assigned_on",
  "returned_on",
  "replaced_on",
  "assigned_by_name",
  "replaced_by_name",
  "returned_to_name",
  "asset_complaints",
  "prev_assigned_to_name",
  "remarks",
];

const returnHistoryLabels = {
  employee_name: "Employee",
  asset_description: "Asset",
  model_no: "Model No",
  serial_no: "Serial No",
  transaction_status: "Transaction Status",
  assigned_on: "Assigned Date",
  returned_on: "Returned Date",
  replaced_on: "Replaced Date",
  assigned_by_name: "Assigned By",
  replaced_by_name: "Replaced By",
  returned_to_name: "Handed Over To",
  asset_complaints: "Complaints/Reason",
  prev_assigned_to_name: "Prev Assigned To",
  remarks: "Remarks",
};

const Assets = () => {
  const [isEditing, setIsEditing] = useState(false); // Added isEditing state
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // or "error"
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [assets, setAssets] = useState([]);
  const [filters, setFilters] = useState({ deleteFlag: "ACTIVE" });
  const [errors, setErrors] = useState({});
  const [deleteAssetName, setDeleteAssetName] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [anchorEls, setAnchorEls] = useState({});
  const [statusOptions, setStatusOptions] = useState([]);
  const [deleteId, setDeleteId] = useState([]);
  const [columnVisibility, setColumnVisibility] = useState(() => {
    const initial = {};
    AssetFields.forEach((f) => (initial[f] = true));
    return initial;
  });
  const [columnAnchorEl, setColumnAnchorEl] = useState(null);
  const [historyColumnVisibility, setHistoryColumnVisibility] = useState(() => {
    const initial = {};
    returnHistoryFields.forEach((f) => (initial[f] = true));
    return initial;
  });
  const [historyColumnAnchorEl, setHistoryColumnAnchorEl] = useState(null);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [newAsset, setNewAsset] = useState({
    delete_flag: "N",
    data_source: "UI",
    created_by: "system",
    created_on_date: new Date(),
  });
  const [EditAsset, setEditAsset] = useState({});
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [search, setSearch] = useState("");

  const [selectedAssetId, setSelectedAssetId] = useState(null);
  const [openAssetDialog, setOpenAssetDialog] = useState(false);
  const { empId, boId, hasPermission, roles } = useCurrentUser();
  const [activeTab, setActiveTab] = useState(0); // 0 = Assets, 1 = Returned History
  const [returnHistory, setReturnHistory] = useState([]);
  const [returnHistoryTotal, setReturnHistoryTotal] = useState(0);
  const [historyAnchorEls, setHistoryAnchorEls] = useState({});
  const [historyFilters, setHistoryFilters] = useState({});
  const handleEditClick = (row) => {
    setEditAsset({
      ...row,
      purchase_date: formatDateLocal_TF(row.purchase_date),
      warranty_validity: formatDateLocal_TF(row.warranty_validity),
      service_date: formatDateLocal_TF(row.service_date),
    });
    setIsEditing(true); // Set to Update mode
    setTimeout(() => {
      setEditOpen(true);
    }, 0); // Ensure dialog opens after state updates
  };
  const handleCloseAssetDialog = () => {
    setSelectedAssetId(null);
    setOpenAssetDialog(false);
  };
  const rowsPerPage = 10;

  const fetchempAssets = useCallback(async () => {
    try {
      const params = {
        page: page + 1,
        limit: rowsPerPage,
        ...filters,
        search: search.trim(),
        ...(boId ? { boId } : {}),
      };
      const response = await axios.get(`${BASE_URL}/asset/paginated`, {
        params,
      });
      
      setAssets(response.data.data);
      setTotalCount(response.data.total);
    } catch (err) {
      console.error("Error fetching employee assets:", err);
    }
  }, [page, filters, search]);

  const fetchReturnHistory = useCallback(async () => {
    try {
      const params = {
        bo_id: boId,
        empId,
        roles,
        page: page + 1,
        limit: rowsPerPage,
        search: search.trim(),
        ...historyFilters,
      };
      const response = await axios.get(`${BASE_URL}/asset/return-history`, {
        params,
      });
      setReturnHistory(response.data.data);
      setReturnHistoryTotal(response.data.total);
    } catch (err) {
      console.error("Error fetching return history:", err);
    }
  }, [boId, empId, roles, page, historyFilters, search]);

  useEffect(() => {
    fetchempAssets();
  }, [fetchempAssets]);

  useEffect(() => {
    if (activeTab === 1) {
      fetchReturnHistory();
    }
  }, [activeTab, fetchReturnHistory]);

  useEffect(() => {
    setPage(0);
  }, [search, filters, boId]);

  const [dropdownOptions, setDropdownOptions] = useState({
    asset_status: [],
    asset_condition: [],
    warranty_status: [],
  });

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/asset/get-variable-values`);
        setDropdownOptions(res.data); // setting state
      } catch (err) {
        console.error(" Failed to fetch dropdown values", err);
      }
    };

    fetchOptions();
  }, []);

  useEffect(() => {}, [dropdownOptions]);

  const validateField = (name, value, state = {}) => {
    const MAX_INSTALLATION_COST = 1000000;
    const rules = {
      asset_description: (v) => (!v?.trim() ? "Description is required" : ""),
      asset_condition: (v) => (!v?.trim() ? "Asset Condition is required" : ""),
      price: (v) => {
        if (!v.trim()) return "";
        if (isNaN(v)) return "Price must be a number";
        if (!/^\d+(\.\d{0,2})?$/.test(v))
          return "Allowed upto 2 decimal places";
        if (parseFloat(v) < 0) return "Price cannot be negative";
        return "";
      },

      qty: (v) => {
        if (v === "" || v === null || v === undefined) return "";
        if (!/^\d+$/.test(v)) return "Quantity must be a whole number";
        if (Number(v) < 0) return "Quantity cannot be negative";
        return "";
      },

      installation_cost: (v) => {
        if (!v.trim()) return "";
        if (isNaN(v)) return "Cost must be a number";
        if (!/^\d+(\.\d{0,2})?$/.test(v))
          return "Allowed up to 2 decimal places";
        if (parseFloat(v) < 0) return "Cost cannot be negative";
        if (value > MAX_INSTALLATION_COST) {
          return `Cost cannot exceed ${MAX_INSTALLATION_COST.toLocaleString()}`;
        }
        return "";
      },

      purchase_date: () => {
        // optional, no validation needed by itself
        return "";
      },

      warranty_validity: (v) => {
        if (!v || !state.purchase_date) return "";

        if (new Date(v) < new Date(state.purchase_date)) {
          return "Warranty date cannot be before purchase date";
        }
        return "";
      },

      service_date: (v) => {
        if (!v || !state.purchase_date) return "";

        if (new Date(v) < new Date(state.purchase_date)) {
          return "Service date cannot be before purchase date";
        }
        return "";
      },
    };

    return rules[name]?.(value, state) || "";
  };

  const renderField = (
    field,
    state,
    setState,
    dropdownOptions,
    isEditMode = false,
  ) => {
    const handleChange = (e) => {
      const { name } = e.target;
      let { value } = e.target;

      // Only allow numbers (and decimal point) for numeric fields
      if (["price", "installation_cost", "qty"].includes(name)) {
        value = value.replace(/[^0-9.]/g, "");
        // prevent multiple decimal points
        const parts = value.split(".");
        if (parts.length > 2) value = parts[0] + "." + parts.slice(1).join("");
      }

      const updatedState = {
        ...state, // use state passed to renderField
        [name]: value,
      };

      setState(updatedState);

      // Validate current field
      const error = validateField(name, value, updatedState);
      setErrors((prev) => ({ ...prev, [name]: error }));

      // Revalidate dependent fields when purchase_date changes
      if (name === "purchase_date") {
        ["warranty_validity", "service_date"].forEach((f) => {
          const err = validateField(f, updatedState[f], updatedState);
          setErrors((prev) => ({ ...prev, [f]: err }));
        });
      }

      // ALSO revalidate warranty when warranty changes
      if (name === "warranty_validity") {
        const err = validateField("warranty_validity", value, updatedState);
        setErrors((prev) => ({ ...prev, warranty_validity: err }));
      }
    };
    const isDropdown = [
      "asset_status",
      "asset_condition",
      "warranty_status",
    ].includes(field);

    const isDateField = [
      "purchase_date",
      "warranty_validity",
      "service_date",
    ].includes(field);

    if (field === "bo_id") return null;

    return isDateField ? (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label={fieldLabels[field] || field}
          value={state[field] ? dayjs(state[field]) : null}
          onChange={(newValue) => {
            handleChange({
              target: {
                name: field,
                value: newValue ? newValue.format("YYYY-MM-DD") : "",
              },
            });
          }}
          slotProps={{
            textField: {
              error: Boolean(errors[field]),
              helperText: errors[field] || "",
              placeholder: "MM/DD/YYYY",
              InputLabelProps: {
                shrink: true,
                sx: {
                  transform: "translate(10px, 10px) scale(2)", // adjust as needed
                  transformOrigin: "top left",
                  "&.MuiInputLabel-shrink": {
                    transform: "translate(9px, -8px) scale(0.75)", // adjust as needed
                    transformOrigin: "top left",
                  },
                },
              },
              InputProps: {
                sx: {
                  height: 35,
                  minHeight: 35,
                  fontSize: "12px",
                  padding: "0 10px",
                  "& .MuiInputBase-input": {
                    padding: "6px 10px",
                  },
                },
              },
              sx: {
                width: "220px",
                "& .MuiInputBase-root": {
                  minHeight: 35,
                },
                "& .MuiInputLabel-root": {
                  fontSize: "14px",
                },
                "& .MuiFormHelperText-root": {
                  minHeight: "18px",
                  lineHeight: "18px",
                  marginTop: "2px", // reduce spacing above error text
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                },
                backgroundColor: "#fafafa",
                mt: 0.5,
                mb: 0,
              },
            },
          }}
        />
      </LocalizationProvider>
    ) : (
      <TextField
        key={field}
        select={isDropdown}
        //    label={fieldLabels[field] || field}
        label={
          <>
            {fieldLabels[field] || field}
            {(field === "asset_description" || field === "asset_condition") && (
              <span> *</span>
            )}
          </>
        }
        name={field}
        value={state[field] || ""}
        onChange={handleChange}
        disabled={isEditMode && field === "asset_id"}
        fullWidth
        size="small"
        error={Boolean(errors[field])}
        helperText={errors[field] || ""}
        InputLabelProps={{
          shrink: true,
          sx: {
            fontSize: 14,
            fontFamily: "Arial",
            transform: "translate(10px, 10px) scale(1)",
            transformOrigin: "top left",
            "&.MuiInputLabel-shrink": {
              transform: "translate(9px, -8px) scale(0.75)",
              transformOrigin: "top left",
            },
          },
        }}
        SelectProps={{
          MenuProps: {
            PaperProps: {
              sx: {
                fontSize: "12px",
              },
            },
            MenuListProps: {
              sx: {
                fontSize: "12px",
                padding: 0,
              },
            },
          },
        }}
        sx={{
          "& .MuiInputBase-root": {
            fontSize: "12px",
            fontFamily: "Arial",
            width: "220px",
            minHeight: 35,
          },
          "& .MuiInputLabel-root": {
            fontSize: "14px",
            fontFamily: "Arial",
          },
          "& .MuiFormHelperText-root": {
            minHeight: "18px",
            lineHeight: "18px",
            marginTop: "2px", // reduce spacing above error text
            whiteSpace: "normal",
            wordBreak: "break-word",
          },
          mt: 0.5,
          mb: 0,
        }}
      >
        {isDropdown &&
          dropdownOptions[field]?.map((option) => (
            <MenuItem key={option} value={option} sx={{ fontSize: "12px" }}>
              {option}
            </MenuItem>
          ))}
      </TextField>
    );
  };

  const handleAdd = async () => {
    // Validate all required fields
    const fieldsToValidate = ["asset_description", "asset_condition"];
    const newErrors = {};

    fieldsToValidate.forEach((field) => {
      const error = validateField(field, newAsset[field], newAsset);
      if (error) newErrors[field] = error;
    });

    // Check for duplicate serial number
    if (newAsset.serial_no && newAsset.serial_no.trim() !== "") {
      const isDuplicate = assets.some(
        (asset) =>
          asset.serial_no &&
          asset.serial_no.trim().toLowerCase() ===
            newAsset.serial_no.trim().toLowerCase(),
      );
      if (isDuplicate) {
        newErrors.serial_no = "Serial number already exists";
      }
    }

    // Check for duplicate warranty number
    if (newAsset.warranty_number && newAsset.warranty_number.trim() !== "") {
      const isDuplicate = assets.some(
        (asset) => asset.warranty_number && asset.warranty_number.trim().toLowerCase() ===
            newAsset.warranty_number.trim().toLowerCase(),
      );
      if (isDuplicate) {
        newErrors.warranty_number = "Warranty number already exists";
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return; // stop submission
    }
    try {
      const assetToAdd = {
        ...newAsset,
        bo_id: boId, // assign boId to bo_id here
        created_by: empId,
        modified_by: empId,
        created_on_date: new Date(),
      };

      await axios.post(`${BASE_URL}/asset`, assetToAdd);

      setOpen(false);
      setNewAsset({
        bo_id: boId, // keep bo_id in the reset state too
        created_by: empId,
        modified_by: empId,
        created_on_date: new Date(),
      });

      setSuccessMessage("New Asset added successfully!");
      setTimeout(() => setSuccessMessage(""), 5000);
      fetchempAssets();
    } catch (err) {
      console.error("Add failed:", err.response?.data || err.message);
      setErrorMessage(`Failed to add asset: ${err.message}`);
      setTimeout(() => setErrorMessage(""), 5000);
    }
  };
  useEffect(() => {
    const fetchStatusFlags = async () => {
      try {
        const res = await fetch(`${BASE_URL}/commonVariables/statusFlag`);
        const data = await res.json();
        setStatusOptions(data); // [{ code: "ACTIVE", label: "Active" }, ...]
      } catch (err) {
        console.error("Failed to fetch employee status flags:", err);
      }
    };

    fetchStatusFlags();
  }, []);
  const handleEdit = async () => {
    try {
      const {
        asset_id,
        asset_description,
        purchase_at,
        manufacturer,
        model_no,
        model_name,
        serial_no,
        price,
        purchase_date,
        warranty_number,
        warranty_validity,
        warranty_status,
        service_date,
        service_by,
        installation_cost,
        qty,
        asset_status,
        asset_condition,
        modified_by: empId,
      } = EditAsset;

      await axios.put(`${BASE_URL}/asset/${asset_id}/${boId}`, {
        asset_description,
        purchase_at,
        manufacturer,
        model_no,
        model_name,
        serial_no,
        price,
        purchase_date,
        warranty_number,
        warranty_validity,
        warranty_status,
        service_date,
        service_by,
        installation_cost,
        qty,
        asset_status,
        asset_condition,
      });

      setEditOpen(false);
      setEditAsset({});
      setSuccessMessage("Asset updated successfully!");
      setTimeout(() => setSuccessMessage(""), 5000);
      fetchempAssets();
    } catch (err) {
      console.error("Update failed:", err.response?.data || err.message);
      setErrorMessage(`Failed to update asset: ${err.message}`);
      setTimeout(() => setErrorMessage(""), 5000);
    }
  };

  const handleFilterIconClick = (field, event) => {
    setAnchorEls((prev) => ({ ...prev, [field]: event.currentTarget }));
  };

  const handleFilterClose = (field) => {
    setAnchorEls((prev) => ({ ...prev, [field]: null }));
  };
  const handleDelete = (asset_id, asset_description) => {
    setDeleteId(asset_id);
    setDeleteAssetName(asset_description);
    setConfirmOpen(true);
  };
  const confirmDelete = async (asset_id) => {
    try {
      await axios.delete(`${BASE_URL}/asset/${deleteId}/${boId}`);
      setSuccessMessage("Record Deleted Successfully..");
      setTimeout(() => setSuccessMessage(""), 5000);
      fetchempAssets();
    } catch (err) {
      console.error("Delete failed:", err.stack || err);
      // Check if backend sent a custom message
      if (err.response && err.response.data && err.response.data.error) {
        setErrorMessage(err.response.data.error); // shows "linked to projects" message
      } else {
        setErrorMessage("Something went wrong");
      }
      setTimeout(() => setErrorMessage(""), 5000);
    } finally {
      setConfirmOpen(false);
      setDeleteId(null);
    }
  };

  const handleToggleFlag = async (asset_id, currentFlag) => {
    const newFlag = currentFlag === "Y" ? "N" : "Y";
    try {
      const res = await fetch(
        `${BASE_URL}/asset/${asset_id}/${boId}/toggle-flag`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ delete_flag: newFlag }),
        },
      );

      if (res.ok) {
        const updated = await res.json(); // Important: get updated flag from backend
        setAssets((prev) =>
          prev.map((ass) =>
            ass.asset_id === updated.asset_id
              ? { ...ass, delete_flag: updated.delete_flag }
              : ass,
          ),
        );
        setSuccessMessage("Toggle Flag updated Successfully..");
        setTimeout(() => setSuccessMessage(""), 5000);
        fetchempAssets();
      } else {
        console.error("Failed to update Flag");
        setErrorMessage("Failed to update Flag.");
        setTimeout(() => setErrorMessage(""), 5000);
      }
    } catch (error) {
      console.error("Error updating flag:", error);
    }
  };

  return (
    <MainLayout>
      {successMessage && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {successMessage}
        </Alert>
      )}
      {errorMessage && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {errorMessage}
        </Alert>
      )}
      <Box
        display="flex"
        justifyContent="flex-start"
        alignItems="center"
        mb={2}
        gap={1.5}
      >
        <IconButton onClick={(e) => activeTab === 0 ? setColumnAnchorEl(e.currentTarget) : setHistoryColumnAnchorEl(e.currentTarget)}>
          <SettingsIcon />
        </IconButton>
        
        {/* Settings Popover for Assets Tab */}
        <Popover
          open={Boolean(columnAnchorEl)}
          anchorEl={columnAnchorEl}
          onClose={() => setColumnAnchorEl(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            sx: {
              mt: 1,
              p: 1,
              width: 250,
              maxHeight: 300,
              overflowY: "auto",
              borderRadius: 2,
            },
          }}
        >
          {AssetFields.map((field) => (
            <MenuItem key={field} disableGutters sx={{ p: 0, mb: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  border: "1px solid #ccc",
                  borderRadius: 1.5,
                  px: 2,
                  py: 1,
                  backgroundColor: "#fff",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "0.8rem",
                    color: "#333",
                    fontWeight: "bold",
                  }}
                >
                  {fieldLabels[field]}
                </Typography>
                <Switch
                  size="small"
                  checked={columnVisibility[field]}
                  onChange={() =>
                    setColumnVisibility((prev) => ({
                      ...prev,
                      [field]: !prev[field],
                    }))
                  }
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "#2DB0E4",
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#2DB0E4",
                    },
                  }}
                />
              </Box>
            </MenuItem>
          ))}
        </Popover>

        {/* Settings Popover for Return History Tab */}
        <Popover
          open={Boolean(historyColumnAnchorEl)}
          anchorEl={historyColumnAnchorEl}
          onClose={() => setHistoryColumnAnchorEl(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            sx: {
              mt: 1,
              p: 1,
              width: 250,
              maxHeight: 300,
              overflowY: "auto",
              borderRadius: 2,
            },
          }}
        >
          {returnHistoryFields.map((field) => (
            <MenuItem key={field} disableGutters sx={{ p: 0, mb: 1 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  border: "1px solid #ccc",
                  borderRadius: 1.5,
                  px: 2,
                  py: 1,
                  backgroundColor: "#fff",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "0.8rem",
                    color: "#333",
                    fontWeight: "bold",
                  }}
                >
                  {returnHistoryLabels[field]}
                </Typography>
                <Switch
                  size="small"
                  checked={historyColumnVisibility[field]}
                  onChange={() =>
                    setHistoryColumnVisibility((prev) => ({
                      ...prev,
                      [field]: !prev[field],
                    }))
                  }
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "#2DB0E4",
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#2DB0E4",
                    },
                  }}
                />
              </Box>
            </MenuItem>
          ))}
        </Popover>

        <Button
          variant="contained"
          size="small"
          // onClick={() => setOpen(true)}
          onClick={() => {
            setIsEditing(false);
            setNewAsset({}); //  Reset the form data
            setOpen(true); // Then open the dialog
            setErrors({});
          }}
          sx={{
            fontWeight: "bold",
            borderRadius: "8px",
            px: 2.5,
            height: 36,
            backgroundColor: "#2DB0E4",
          }}
          startIcon={<Add />}
        >
          Add
        </Button>
        <TextField
          size="small"
          placeholder="Search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{
            width: 250,
            "& input": { fontSize: 14 }, // input + placeholder
            "& input::placeholder": { fontSize: 12 }, // placeholder only
          }}
          InputProps={{
            sx: {
              height: 36, // Reduce overall input height
              paddingRight: 0,
            },
            startAdornment: (
              <InputAdornment position="start">
                <Search fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
        {/* Status Dropdown */}
        <TextField
          select
          size="small"
          label="Status"
          value={filters.deleteFlag || ""}
          onChange={(e) =>
            setFilters((prev) => ({ ...prev, deleteFlag: e.target.value }))
          }
          sx={{
            width: 200,
            // Make height match the 36px of the search field
            "& .MuiInputBase-root": {
              height: 36,
            },

            // Fix vertical alignment of text
            "& .MuiSelect-select": {
              display: "flex",
              alignItems: "center",
              fontSize: 12,
              padding: "0 14px",
            },

            // Label font size
            "& .MuiInputLabel-root": { fontSize: "14px" },
          }}
          SelectProps={{
            MenuProps: {
              PaperProps: {
                sx: {
                  "& .MuiMenuItem-root": {
                    fontSize: "14px",
                    minHeight: "32px",
                  },
                },
              },
            },
          }}
        >
          <MenuItem value="All">All</MenuItem>
          {statusOptions.map((opt) => (
            <MenuItem key={opt.code} value={opt.code}>
              {opt.label}
            </MenuItem>
          ))}
        </TextField>
      </Box>

      {/* Tabs: Assets / Returned History */}
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 1 }}>
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => {
            setActiveTab(newValue);
            setPage(0);
          }}
          sx={{
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              fontSize: "14px",
            },
            "& .Mui-selected": { color: "#2DB0E4 !important" },
            "& .MuiTabs-indicator": { backgroundColor: "#2DB0E4" },
          }}
        >
          <Tab label="Assets" />
          <Tab label="Returned History" />
        </Tabs>
      </Box>

      <Box
        sx={{
          width: "100%",
          overflowX: "auto",
          px: 0,
          py: 2,
          mt: "-10px",
          // p: { xs: 1, sm: 2 }, mt: "-10px",
        }}
      >
        <ThemeProvider theme={Table_theme}>
          <CssBaseline />
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {activeTab === 0 && (
                    <>
                      <TableCell
                        sx={{
                          whiteSpace: "nowrap",
                          textAlign: "center",
                          verticalAlign: "middle",
                        }}
                      >
                        Actions
                      </TableCell>

                      {AssetFields.filter((f) => columnVisibility[f]).map(
                        (field) => (
                          <TableCell
                            key={field}
                            sx={{
                              whiteSpace: "nowrap",
                              textAlign: "center",
                              verticalAlign: "middle",
                            }}
                          >
                            <Box
                              display="inline-flex"
                              alignItems="center"
                              justifyContent="center"
                              sx={{ gap: 0.5 }}
                            >
                              <strong>{fieldLabels[field]}</strong>
                              <IconButton
                                size="small"
                                onClick={(e) => handleFilterIconClick(field, e)}
                              >
                                <FilterList fontSize="small" />
                              </IconButton>
                            </Box>

                            <Popover
                              open={Boolean(anchorEls[field])}
                              anchorEl={anchorEls[field]}
                              onClose={() => handleFilterClose(field)}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                              }}
                            >
                              <Box
                                p={2}
                                display="flex"
                                flexDirection="column"
                                gap={1}
                                width={200}
                              >
                                <TextField
                                  size="small"
                                  fullWidth
                                  placeholder={`Filter ${fieldLabels[field]}`}
                                  value={filters[field] || ""}
                                  onChange={(e) =>
                                    setFilters((prev) => ({
                                      ...prev,
                                      [field]: e.target.value,
                                    }))
                                  }
                                />
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <Button
                                    variant="contained"
                                    size="small"
                                    onClick={() => handleFilterClose(field)}
                                    sx={{ minWidth: 70 }}
                                  >
                                    Apply
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={() => {
                                      setFilters((prev) => ({
                                        ...prev,
                                        [field]: "",
                                      }));
                                      handleFilterClose(field);
                                    }}
                                    sx={{ minWidth: 70 }}
                                  >
                                    Clear
                                  </Button>
                                </Box>
                              </Box>
                            </Popover>
                          </TableCell>
                        ),
                      )}
                    </>
                  )}

                  {/* Return History Tab Headers */}
                  {activeTab === 1 && (
                    <>
                      {returnHistoryFields.filter((f) => historyColumnVisibility[f]).map((field) => (
                        <TableCell
                          key={field}
                          sx={{
                            whiteSpace: "nowrap",
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          <Box
                            display="inline-flex"
                            alignItems="center"
                            justifyContent="center"
                            sx={{ gap: 0.5 }}
                          >
                            <strong>{returnHistoryLabels[field]}</strong>
                            <IconButton
                              size="small"
                              onClick={(e) =>
                                setHistoryAnchorEls((prev) => ({
                                  ...prev,
                                  [field]: e.currentTarget,
                                }))
                              }
                            >
                              <FilterList fontSize="small" />
                            </IconButton>
                          </Box>
                          <Popover
                            open={Boolean(historyAnchorEls[field])}
                            anchorEl={historyAnchorEls[field]}
                            onClose={() =>
                              setHistoryAnchorEls((prev) => ({
                                ...prev,
                                [field]: null,
                              }))
                            }
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "left",
                            }}
                          >
                            <Box
                              p={2}
                              display="flex"
                              flexDirection="column"
                              gap={1}
                              width={200}
                            >
                              <TextField
                                size="small"
                                fullWidth
                                placeholder={`Filter ${returnHistoryLabels[field]}`}
                                value={historyFilters[field] || ""}
                                onChange={(e) =>
                                  setHistoryFilters((prev) => ({
                                    ...prev,
                                    [field]: e.target.value,
                                  }))
                                }
                              />
                              <Box
                                display="flex"
                                justifyContent="space-between"
                              >
                                <Button
                                  variant="contained"
                                  size="small"
                                  onClick={() => {
                                    setHistoryAnchorEls((prev) => ({
                                      ...prev,
                                      [field]: null,
                                    }));
                                    setPage(0); // Reset to first page when filter applied
                                  }}
                                  sx={{ minWidth: 70 }}
                                >
                                  Apply
                                </Button>
                                <Button
                                  variant="outlined"
                                  size="small"
                                  onClick={() => {
                                    setHistoryFilters((prev) => ({
                                      ...prev,
                                      [field]: "",
                                    }));
                                    setHistoryAnchorEls((prev) => ({
                                      ...prev,
                                      [field]: null,
                                    }));
                                  }}
                                  sx={{ minWidth: 70 }}
                                >
                                  Clear
                                </Button>
                              </Box>
                            </Box>
                          </Popover>
                        </TableCell>
                      ))}
                    </>
                  )}
                </TableRow>
              </TableHead>

              <TableBody>
                {/* Assets Tab */}
                {activeTab === 0 &&
                  assets.map((row, i) => (
                    <TableRow key={i}>
                      <TableCell>
                        <Box display="flex" gap={0.5} justifyContent="center">
                          <Tooltip
                            title={
                              hasPermission("Assets", "Edit")
                                ? "Edit"
                                : "No permission"
                            }
                          >
                            <span>
                              <IconButton
                                size="small"
                                onClick={() => {
                                  if (hasPermission("Assets", "Edit")) {
                                    handleEditClick(row);
                                  }
                                }}
                                disabled={!hasPermission("Assets", "Edit")}
                                sx={{
                                  color: hasPermission("Assets", "Edit")
                                    ? "#2DB0E4"
                                    : "#ccc",
                                }}
                              >
                                <EditOutlinedIcon sx={{ fontSize: "16px" }} />
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip
                            title={
                              hasPermission("Assets", "Delete")
                                ? "Delete"
                                : "No permission"
                            }
                          >
                            <IconButton
                              size="small"
                              onClick={() =>
                                hasPermission("Assets", "Delete") &&
                                handleDelete(
                                  row.asset_id,
                                  row.asset_description,
                                )
                              }
                              disabled={!hasPermission("Assets", "Delete")}
                              sx={{
                                color: hasPermission("Assets", "Delete")
                                  ? "#fc0404ff"
                                  : "#ccc",
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip
                            title={
                              hasPermission("Assets", "Edit")
                                ? "Toggle Delete Flag"
                                : "No permission"
                            }
                          >
                            <IconButton
                              size="small"
                              onClick={() =>
                                hasPermission("Assets", "Edit") &&
                                handleToggleFlag(row.asset_id, row.delete_flag)
                              }
                              disabled={!hasPermission("Assets", "Edit")}
                            >
                              <Flag
                                sx={{
                                  color:
                                    row.delete_flag === "N"
                                      ? "#2E9F50"
                                      : "#FF0C0C",
                                  width: 17,
                                  height: 17,
                                  transition: "color 0.2s",
                                  verticalAlign: "middle",
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>

                      {AssetFields.filter((f) => columnVisibility[f]).map(
                        (field) => (
                          <TableCell
                            key={field}
                            align="left"
                            sx={{
                              whiteSpace: "nowrap",
                              verticalAlign: "middle",
                            }}
                          >
                            {[
                              "purchase_date",
                              "warranty_validity",
                              "service_date",
                            ].includes(field)
                              ? row[field]
                                ? formatDateLocal(row[field])
                                : ""
                              : row[field]}
                          </TableCell>
                        ),
                      )}
                    </TableRow>
                  ))}

                {/* Returned History Tab */}
                {activeTab === 1 &&
                  returnHistory.map((row, i) => (
                      <TableRow
                        key={i}
                        sx={{
                          "& td": {
                            fontSize: "12px",
                            paddingTop: "10px",
                            paddingBottom: "10px",
                          },
                        }}
                      >
                        {returnHistoryFields.filter((f) => historyColumnVisibility[f]).map((field) => (
                          <TableCell
                            key={field}
                            sx={{
                              whiteSpace: "nowrap",
                              textAlign: "left",
                              verticalAlign: "middle",
                              fontSize: "12px",
                            }}
                          >
                            {row[field] ?? "-"}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box display="flex" justifyContent="center" mt={2}>
            <Pagination
              count={Math.ceil(
                (activeTab === 0 ? totalCount : returnHistoryTotal) /
                  rowsPerPage,
              )}
              page={page + 1} // Add +1 to match MUI pagination (1-based)
              onChange={(_, newPage) => setPage(newPage - 1)} // Subtract 1 to set back to 0-based index
              color="primary"
              variant="outlined"
              shape="rounded"
              sx={{
                "& .MuiPaginationItem-root": {
                  borderRadius: "8px",
                  minWidth: "32px",
                  height: "32px",
                  fontSize: "14px",
                },
                "& .Mui-selected": {
                  backgroundColor: "#b3dbea !important",
                  color: "black",
                  fontWeight: "bold",
                },
                "& .MuiPaginationItem-ellipsis": {
                  display: "none",
                },
              }}
            />
          </Box>
        </ThemeProvider>
        <AssetDetailSubpage
          open={openAssetDialog}
          onClose={handleCloseAssetDialog}
          asset_id={selectedAssetId}
        />
      </Box>
      <ThemeProvider theme={FormThemes}>
        <CssBaseline />
        <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            {`Are you sure you want to permanently delete ${deleteAssetName}?`}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
            <Button onClick={confirmDelete} color="error" variant="contained">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={open || editOpen}
          onClose={(event, reason) => {
            // Prevent closing on backdrop click or escape key
            if (reason === "backdropClick" || reason === "escapeKeyDown") {
              return;
            }
            setOpen(false);
            setEditOpen(false);
          }}
          fullWidth
          maxWidth="sm"
          sx={{
            "& .MuiDialog-paper": {
              borderRadius: 5,
              overflow: "visible",
              width: "550px", // Manually control the width if needed
              maxWidth: "95vw", // Responsive max
            },
          }}
        >
          <DialogTitle
            sx={{
              borderRadius: "12px",
              bgcolor: "#f5f5f5",
              p: 1,
              fontSize: "16px",
              fontWeight: 600,
            }}
          >
            {isEditing ? "Update Asset" : "Add Asset"}
            <IconButton
              aria-label="close"
              onClick={() => {
                setOpen(false);
                setEditOpen(false);
                setIsEditing(false);
                // setFieldErrors({});
              }}
              sx={{ position: "absolute", right: 8, top: 5 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent
            dividers
            sx={{
              p: "18px 30px",
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
            }}
          >
            <Grid container spacing={2} sx={{ width: "100%", px: 1, m: 0 }}>
              {AssetpopupFields.map((field, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  {renderField(
                    field,
                    isEditing ? EditAsset : newAsset,
                    isEditing ? setEditAsset : setNewAsset,
                    dropdownOptions,
                    isEditing,
                  )}
                </Grid>
              ))}
            </Grid>
          </DialogContent>

          <DialogActions sx={{ p: "10px 24px", justifyContent: "flex-end" }}>
            <Button
              onClick={() => {
                setNewAsset({}); //  Reset the form data
                setOpen(false); // Then open the dialog
                setEditOpen(false);
                setIsEditing(false);
                // setFieldErrors({});
                setErrors({});
              }}
              variant="outlined"
              color="inherit"
              sx={{ mr: 1, color: "#555", borderColor: "#ccc" }}
            >
              Cancel
            </Button>
            <Button
              onClick={isEditing ? handleEdit : handleAdd}
              variant="contained"
              color="primary"
              sx={{
                fontWeight: "bold",
                borderRadius: "8px",
                px: 2.5,
                height: 36,
                ...(isEditing
                  ? {
                      backgroundColor: "#4CAF50",
                      "&:hover": { backgroundColor: "#45a049" },
                    }
                  : {
                      backgroundColor: "#2DB0E4",
                      "&:hover": { backgroundColor: "#1D87B0" },
                    }),
              }}
            >
              {isEditing ? "Update" : "Save"}
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => setShowSnackbar(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setShowSnackbar(false)}
          severity={snackbarSeverity} // now dynamic
          sx={{ width: "100%" }}
        >
          {snackbarMsg}
        </Alert>
      </Snackbar>
    </MainLayout>
  );
};
export default Assets;

